import { combineReducers } from 'redux';
import rolesReducer from './Roles/store/roleReducer';

export const reducers = combineReducers({
    roles: rolesReducer
});